// ratings colors
var COLOR_RATING_ONE = '#CC0000';
var COLOR_RATING_TWO = '#E83737';
var COLOR_RATING_THREE = '#FF5722';
var COLOR_RATING_FOUR = '#E08104';
var COLOR_RATING_FIVE = '#FACD5D';
var COLOR_RATING_SIX = '#A3C965';
var COLOR_RATING_SEVEN = '#6CBB59';
var COLOR_RATING_EIGHT = '#59BB8C';
var COLOR_RATING_NINE = '#04AF72';
var COLOR_RATING_TEN = '#02A651';
var RATINGS_ARRAY_LONG = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
var COLORS = [
    COLOR_RATING_ONE,
    COLOR_RATING_TWO,
    COLOR_RATING_THREE,
    COLOR_RATING_FOUR,
    COLOR_RATING_FIVE,
    COLOR_RATING_SIX,
    COLOR_RATING_SEVEN,
    COLOR_RATING_EIGHT,
    COLOR_RATING_NINE,
    COLOR_RATING_TEN
];
var FeedbackHelper = /** @class */ (function () {
    function FeedbackHelper() {
    }
    FeedbackHelper.getRatingsRange = function () {
        return RATINGS_ARRAY_LONG;
    };
    FeedbackHelper.getRatingsColor = function (value) {
        var index = value - 1;
        return COLORS[index];
    };
    return FeedbackHelper;
}());

export { COLOR_RATING_EIGHT, COLOR_RATING_FIVE, COLOR_RATING_FOUR, COLOR_RATING_NINE, COLOR_RATING_ONE, COLOR_RATING_SEVEN, COLOR_RATING_SIX, COLOR_RATING_TEN, COLOR_RATING_THREE, COLOR_RATING_TWO, RATINGS_ARRAY_LONG, FeedbackHelper as default };
//# sourceMappingURL=npsFeedback.helper.js.map
